import type { ReactNode } from 'react'
import { Box, Group, Text } from '@grovus/design-system'

interface Props {
  children: ReactNode
  /** The EN/RU and theme controls, positioned top-right; omitted on the checking/retry screens. */
  topRight?: ReactNode
  /** Panel width in px. Defaults to the wireframe's 392px; FirstRun uses a wider 452px. */
  maxWidth?: number
}

/** The wireframe's centered panel, shared by SignInScreen, FirstRun and the boundary's checking/retry states. */
export function AuthLayout({ children, topRight, maxWidth = 392 }: Props) {
  return (
    <Box
      style={{
        position: 'fixed', inset: 0, overflowY: 'auto',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '40px 20px', background: 'var(--mantine-color-body)',
      }}
    >
      {topRight && (
        <Box style={{ position: 'absolute', top: 16, right: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
          {topRight}
        </Box>
      )}

      <Box style={{ width: '100%', maxWidth }}>
        <Group gap={10} align="baseline" mb="lg">
          <Text fw={700} fz={24} style={{ letterSpacing: '-0.02em' }}>GROVUS</Text>
          <Text fz={12} tt="uppercase" className="grv-muted" style={{ letterSpacing: '0.12em' }}>Creative intelligence</Text>
        </Group>
        {children}
      </Box>
    </Box>
  )
}
